export const GAME_TYPE_LABELS = {
  SPIN_WHEEL: 'Spin the Wheel',
  TREASURE_HUNT: 'Treasure Hunt',
  ROLL_DICE: 'Roll the Dice',
  GEM_MATCH: 'Match & Win',
};

export const TRIGGER_TYPE_LABELS = {
  SLAB_UPGRADE: 'Slab Upgrade',
  SINGLE_DAY_SPEND: 'Single-Day Spend',
  BIRTHDAY: 'Birthday',
  ANNIVERSARY: 'Anniversary',
  DATE_BASED: 'Date-Based',
};

// Backend precedence order (GamificationCampaignService.deriveCampaignStatus,
// D-09/D-10, 09-CONTEXT.md): DEACTIVATED -> ENDED -> DRAFT -> SCHEDULED ->
// ACTIVE. DRAFT is new in Phase 9 (an unpublished campaign) — the four
// pre-existing labels keep their exact prior meaning; this only adds one
// option to the set the status filter already sends to the server.
export const STATUS_LABELS = {
  DEACTIVATED: 'Deactivated',
  ENDED: 'Ended',
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  ACTIVE: 'Active',
};
